import React, { useEffect, useState } from 'react'
import useNextRewardCountdown from 'src/hooks/useNextRewardCountdown';

function NextRewardsPeriod() {
  const { timeRemaining, loading, error } = useNextRewardCountdown();
  const [countdown, setCountdown] = useState('');

  useEffect(() => {
    const formatTime = () => {
      const hours = Math.floor(timeRemaining / 3600);
      const minutes = Math.floor((timeRemaining % 3600) / 60);
      return `${hours} hours ${minutes} minutes`;
    };

    if (timeRemaining !== null) {
      setCountdown(formatTime());
    }
  }, [timeRemaining]);


  return (
    <div className='nextRewardsPeriod'>
        <img className='left' src="assets/images/next-period-reward-1.png" alt="Next reward period illustration 1" />
        <div>
            <span>Next Reward Period</span>
            <strong>{(loading || error ? '' : countdown)}</strong>
        </div>
        <img className='right' src="assets/images/next-period-reward-2.png" alt="Next reward period illustration 2" />
    </div>
  )
}

export default NextRewardsPeriod